import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ChecklistIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M14.6666 5.02323H8.66659V6.35656H14.6666V5.02323ZM14.6666 10.3566H8.66659V11.6899H14.6666V10.3566ZM3.69325 7.6899L1.33325 5.3299L2.27325 4.3899L3.68659 5.80323L6.51325 2.97656L7.45325 3.91656L3.69325 7.6899ZM3.69325 13.0232L1.33325 10.6632L2.27325 9.72323L3.68659 11.1366L6.51325 8.3099L7.45325 9.2499L3.69325 13.0232Z" />
  </Icon>
);

export default memo(ChecklistIcon);
